import {
    FETCH_DASHBOARD_SENSOR_TYPES,
    FETCH_DASHBOARD_EQUIPMENT_TYPES
} from '../actions/actionTypes';

const initialState = {
    sensorTypes:    [],
    equipmentTypes: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DASHBOARD_EQUIPMENT_TYPES:
            return {
                ...state,
                equipmentTypes: [...action.payload]
            };
        case FETCH_DASHBOARD_SENSOR_TYPES:
            return {
                ...state,
                sensorTypes: [...action.payload]
            };
        default:
            return state;
    }
};
